module.exports = __webpack_public_path__ + "static/media/natalie.cd337e2c.jpg";